"use strict";
exports.__esModule = true;
exports.MinConstraint = exports.MaxConstraint = exports.DateConstraint = exports.TextConstraint = exports.YearConstraint = exports.DoubleConstraint = exports.IntegerConstraint = exports.Constraint = void 0;
var angular = require("angular");
var Constraint = /** @class */ (function () {
    function Constraint(constraintType) {
        this.constraintType = constraintType;
        switch (constraintType) {
            case "double":
                this.__delegate = new DoubleConstraint();
                break;
            case "integer":
                this.__delegate = new IntegerConstraint();
                break;
            case "year":
                this.__delegate = new YearConstraint();
                break;
            case "string":
            case "text":
                this.__delegate = new TextConstraint();
                break;
            case "date":
                this.__delegate = new DateConstraint();
                break;
            case "min":
                this.__delegate = new MinConstraint();
                break;
            case "max":
                this.__delegate = new MaxConstraint();
                break;
            case "min":
                this.__delegate = new MinConstraint();
                break;
            case "max":
                this.__delegate = new MaxConstraint();
                break;
        }
    }
    Constraint.prototype.isValidFor = function (value) {
        return this.__delegate.isValidFor(value);
    };
    Constraint.prototype.errorMessage = function () {
        return "Enter a valid " + this.__delegate.toString();
    };
    Constraint.prototype.isOrdered = function (val) {
        var tmpVal = angular.copy(val);
        var ascending = JSON.stringify(tmpVal.sort(function (a, b) { return a - b; }));
        var descending = JSON.stringify(tmpVal.sort(function (a, b) { return b - a; }));
        return JSON.stringify(val) == ascending || JSON.stringify(val) == descending;
    };
    return Constraint;
}());
exports.Constraint = Constraint;
var IntegerConstraint = /** @class */ (function () {
    function IntegerConstraint() {
        // INTEGER_REGEXP: any = /^-?\d*$/;
        this.INTEGER_REGEXP = /^-?\d+$/;
    }
    IntegerConstraint.prototype.isValidFor = function (value) {
        return value !== "" ? this.INTEGER_REGEXP.test(value) : false;
    };
    IntegerConstraint.prototype.toString = function () {
        return "integer";
    };
    return IntegerConstraint;
}());
exports.IntegerConstraint = IntegerConstraint;
var DoubleConstraint = /** @class */ (function () {
    function DoubleConstraint() {
        // FLOAT_REGEXP: any = /^([-+])?(\d+(,\d{3})*)?((\.)\d+)?$/;
        this.FLOAT_REGEXP = /^([-+])?((\d+(,\d{3})*)|((\.)\d+))+$/;
    }
    DoubleConstraint.prototype.isValidFor = function (value) {
        if (isNaN(value) && !value) {
            value = "";
        }
        else {
            value = value.toString();
        }
        // value = value.replace(",", "");
        return value !== "" ? this.FLOAT_REGEXP.test(value) : false;
    };
    DoubleConstraint.prototype.toString = function () {
        return "number";
    };
    return DoubleConstraint;
}());
exports.DoubleConstraint = DoubleConstraint;
var YearConstraint = /** @class */ (function () {
    function YearConstraint() {
    }
    YearConstraint.prototype.isValidFor = function (value) {
        var ic = new IntegerConstraint();
        if (ic.isValidFor(value)) {
            var num = Number(value);
            if (num >= 1900 && num <= 2100) {
                return true;
            }
        }
        return false;
    };
    YearConstraint.prototype.toString = function () {
        return "year";
    };
    return YearConstraint;
}());
exports.YearConstraint = YearConstraint;
var TextConstraint = /** @class */ (function () {
    function TextConstraint() {
    }
    TextConstraint.prototype.isValidFor = function (value) {
        return true;
    };
    TextConstraint.prototype.toString = function () {
        return "text";
    };
    return TextConstraint;
}());
exports.TextConstraint = TextConstraint;
var DateConstraint = /** @class */ (function () {
    function DateConstraint() {
    }
    DateConstraint.prototype.isValidFor = function (value) {
        return true;
    };
    DateConstraint.prototype.toString = function () {
        return "date";
    };
    return DateConstraint;
}());
exports.DateConstraint = DateConstraint;
var MaxConstraint = /** @class */ (function () {
    function MaxConstraint() {
    }
    MaxConstraint.prototype.isValidFor = function (input) {
        return parseFloat(input.Value) <= parseFloat(input.Max);
    };
    MaxConstraint.prototype.toString = function () {
        return "max";
    };
    return MaxConstraint;
}());
exports.MaxConstraint = MaxConstraint;
var MinConstraint = /** @class */ (function () {
    function MinConstraint() {
    }
    MinConstraint.prototype.isValidFor = function (input) {
        return parseFloat(input.Value) >= parseFloat(input.Min);
    };
    MinConstraint.prototype.toString = function () {
        return "min";
    };
    return MinConstraint;
}());
exports.MinConstraint = MinConstraint;
exports["default"] = Constraint;
//# sourceMappingURL=constraints.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/app/js/logic/constraints.js